export default __webpack_public_path__ + "static/workers-44967cc1a563d80763a69f31b275e708.png";